import { useMemo } from 'react'

import { type OptionItem, CustomSelect } from '@wartek-id/select'
import { Text } from '@wartek-id/text-v1'

import type { PerilakuKerjaAspek } from 'types/kinerja'

interface PerilakuKerjaItemProps {
  aspek: PerilakuKerjaAspek
  index: number
  selectedIndikatorValue?: string
  selectedEkspektasiValue?: string
  isIndikatorInvalid?: boolean
  isEkpektasiInvalid?: boolean
  isReadOnly?: boolean
  onChangeIndikator: (value: OptionItem) => void
  onChangeEkspektasi: (indikatorValue: string, value: OptionItem) => void
}

export function PerilakuKerjaItem({
  aspek,
  index,
  onChangeIndikator,
  onChangeEkspektasi,
  isIndikatorInvalid = false,
  isEkpektasiInvalid = false,
  isReadOnly = false,
  selectedIndikatorValue,
  selectedEkspektasiValue,
}: PerilakuKerjaItemProps) {
  const indikatorOptions = useMemo(
    () =>
      aspek.indikator.map((i) => ({
        name: i.value,
      })),
    [aspek.indikator]
  )
  const selectedIndikator = selectedIndikatorValue
    ? indikatorOptions.find((i) => i.name === selectedIndikatorValue)
    : undefined

  const ekspektasiOptions = useMemo(
    () =>
      selectedIndikatorValue
        ? aspek.indikator
            .find((i) => i.value === selectedIndikatorValue)
            ?.ekspektasi.map((e) => ({
              name: e.value,
            })) ?? []
        : [],
    [aspek.indikator, selectedIndikatorValue]
  )
  const selectedEkspektasi = selectedEkspektasiValue
    ? ekspektasiOptions.find((i) => i.name === selectedEkspektasiValue)
    : undefined

  return (
    <div className="flex gap-6 pt-3 pb-6 mb-3 border-b border-b-gray-20 last:mb-0 last:border-b-0">
      <div className="px-2 flex gap-6 w-[347px]">
        <div className="flex items-center justify-center w-6 h-6 rounded-full bg-interactive-focused">
          <Text variant="body-sm-bold" color="inverse">
            {index + 1}
          </Text>
        </div>
        <Text variant="heading-lg">{aspek.value}</Text>
      </div>

      <div className="w-[364px]">
        <Text className="mb-1">Indikator Perilaku</Text>
        <CustomSelect
          placeholder="Pilih"
          isDisabled={isReadOnly}
          options={indikatorOptions}
          value={selectedIndikator}
          onChange={onChangeIndikator}
          aria-label="Indikator Perilaku"
          isInvalid={isIndikatorInvalid}
          errorMessage={isIndikatorInvalid ? 'Wajib diisi' : ''}
        />
      </div>

      <div className="w-[364px]">
        <Text className="mb-1">Ekspektasi Khusus Pimpinan</Text>
        <CustomSelect
          placeholder="Pilih"
          isDisabled={!selectedIndikatorValue || isReadOnly}
          options={ekspektasiOptions}
          value={selectedEkspektasi}
          onChange={(value) =>
            onChangeEkspektasi(selectedIndikator.name, value as OptionItem)
          }
          aria-label="Ekspektasi Khusus Pimpinan"
          isInvalid={isEkpektasiInvalid}
          errorMessage={isEkpektasiInvalid ? 'Wajib diisi' : ''}
        />
      </div>
    </div>
  )
}
